import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGb = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 1200 700.14",
	style: { enableBackground: "new 0 0 1200 700.14" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.st0{clip-path:url(#SVGID_00000118397977001958196810000014754366941194579116_);fill:#FFFFFF;}\n	.st1{clip-path:url(#SVGID_00000118397977001958196810000014754366941194579116_);fill:#BD0034;}\n	.st2{clip-path:url(#SVGID_00000118397977001958196810000014754366941194579116_);fill:#1A237B;}\n"
	}), /* @__PURE__ */ _jsx("g", {
		id: "UNITED_KINGDOM_2_",
		children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("rect", {
				id: "SVGID_1_",
				y: .09,
				width: 1200,
				height: 699.96
			}) }),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "SVGID_00000135653306904161478690000002342409774254301374_",
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#SVGID_1_",
					style: { overflow: "visible" }
				})
			}),
			/* @__PURE__ */ _jsx("rect", {
				y: .09,
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#FFFFFF"
				},
				width: 1200,
				height: 699.96
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#BD0034"
				},
				points: " 803.49,253.16 1200,31.2 1200,0.09 1172.66,0.09 720.57,253.16  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#BD0034"
				},
				points: " 784.78,461.02 1200,693.38 1200,646.94 867.74,461.02  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#BD0034"
				},
				points: "0,53.37  355.2,253.16 438.2,253.16 0,6.9  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#BD0034"
				},
				points: " 419.38,461.02 0,696 0,700.05 75.77,700.05 502.41,461.02  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: " 1117.88,0.09 697.73,0.09 697.73,235.39  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: "512.22,0.09  93.75,0.09 512.22,235.39  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: "1200,253.16  1200,92.58 914.98,253.16  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: "1200,619.88  1200,461.02 914.98,461.02  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: " 117.49,700.05 512.22,700.05 512.22,478.86  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: " 697.73,700.05 1093.71,700.05 697.73,478.86  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: "0,461.02  0,627.04 294.94,461.02  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#1A237B"
				},
				points: "0,253.16  294.94,253.16 0,86.89  "
			}),
			/* @__PURE__ */ _jsx("polygon", {
				style: {
					clipPath: "url(#SVGID_00000135653306904161478690000002342409774254301374_)",
					fill: "#BD0034"
				},
				points: "549.34,0.09  549.34,294.74 0,294.74 0,419.53 549.34,419.53 549.34,700.05 660.62,700.05 660.62,419.53 1200,419.53 1200,294.74  660.62,294.74 660.62,0.09  "
			})
		] }) })
	})]
});
export default SvgGb;
